import { Route, Routes } from "react-router-dom"
import LandingPage from "../pages/landing_page"
import { ADMINSATKER, HOME, LOGIN, PROFILE, REDIRECTING, ROOT, PEGAWAI, SATKER_PIMPINAN } from "./routes_name"
import LoginPage from "../pages/login"
import HomePage from "../pages/home"
import ProtectedRoute from "../components/protected_route"
import NotFound from "../components/not_found"
import RedirectingPage from "../pages/redirecting"
import ProfilePage from "../pages/profile"
import AdminSatkerPage from "../pages/admin_satker"
import PegawaiPage from "../pages/pegawai"
import OtpInputPage from "../pages/otp_input"
import OtpShowPage from "../pages/otp_show"
import SatkerPimpinanPage from "../pages/satker_pimpinan"

const Navigation = () => {
    return (
        <Routes>
            <Route
                path={ROOT}
                element={<LandingPage />}
            />
            <Route
                path={LOGIN}
                element={
                    <ProtectedRoute>
                        <LoginPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path={HOME}
                element={
                    <ProtectedRoute isLogin>
                        <HomePage />
                    </ProtectedRoute>
                }
            />
            <Route
                path={REDIRECTING}
                element={
                    <ProtectedRoute isLogin>
                        <RedirectingPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path={PROFILE}
                element={
                    <ProtectedRoute isLogin>
                        <ProfilePage />
                    </ProtectedRoute>
                }
            />
            <Route
                path={ADMINSATKER}
                element={
                    <ProtectedRoute isLogin isRole1>
                        <AdminSatkerPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path={PEGAWAI}
                element={
                    <ProtectedRoute isLogin isRole1 isRole2>
                        <PegawaiPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path={SATKER_PIMPINAN}
                element={
                    <ProtectedRoute isLogin isRole1>
                        <SatkerPimpinanPage />
                    </ProtectedRoute>
                }
            />
            <Route path="/otp-input" element={
                <ProtectedRoute>
                    <OtpInputPage />
                </ProtectedRoute>
            } />
            <Route path="/otp-show" element={
                <ProtectedRoute>
                    <OtpShowPage />
                </ProtectedRoute>
            } />
            <Route
                path="*"
                element={
                    <ProtectedRoute isLogin>
                        <NotFound />
                    </ProtectedRoute>
                }
            />
        </Routes>
    )
}

export default Navigation